import axios from 'axios';
import settings from '../settings';

const api = axios.create({
  baseURL: `${settings.API_URL}`,
  headers: {
    'Content-Type': 'application/json',
  },
});

/* eslint-disable arrow-body-style */
axios.interceptors.request.use((config) => {
  // тут будем добавлять в запрос токен
  return config;
}, (error) => {
  return Promise.reject(error);
});

export default api;
